// 處理格式範例: "2024-12-09T14:22:34.390+08:00" 物件
const TaiwanDate = ({ reportDate }) => {
  // 解析日期字串
  const date = new Date(reportDate)

  // 取得西元年，並轉換成民國年
  const taiwanYear = date.getFullYear() - 1911

  // 格式化日期為民國年格式 "YYY年MM月DD日"
  const formattedDate = `${taiwanYear}年${(date.getMonth() + 1).toString().padStart(2, '0')}月${date
    .getDate()
    .toString()
    .padStart(2, '0')}日`

  return formattedDate
}

// 處理格式範例: "2024-11-19" 字串
const parseDateToTaiwanDate = dateString => {
  // 將傳入的 dateString 轉換為 Date 物件
  const date = new Date(dateString)

  // 計算民國年（民國年）
  const taiwanYear = date.getFullYear() - 1911
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  // 回傳民國年格式 "YYY年MM月DD日"
  return `${taiwanYear}年${month}月${day}日`
}

// 處理格式範例: "2024-11-19" 字串
const parseDateToTaiwanDateSlash = dateString => {
  // 將傳入的 dateString 轉換為 Date 物件
  const date = new Date(dateString)

  // 計算民國年（民國年）
  const taiwanYear = date.getFullYear() - 1911
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  // 回傳民國年格式 "YYY/MM/DD"
  return `${taiwanYear}/${month}/${day}`

  // new Date(dateString).toLocaleDateString('zh-TW', {
  //   year: 'numeric',
  //   month: '2-digit',
  //   day: '2-digit',
  // })
}

const calculateDateRangeDays = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return 0
  }
  // 取得兩日期的 UTC 毫秒數（排除時間影響）
  const start = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
  const end = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())

  // 一天的毫秒數
  const oneDay = 1000 * 60 * 60 * 24

  // 計算天數（不含迄日）
  return (end - start) / oneDay + 1
}

const formatYearMonth = dateString => {
  // 將傳入的 dateString 轉換為 Date 物件
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  return `${year}${month}`
}

export default TaiwanDate
export { parseDateToTaiwanDate }
export { parseDateToTaiwanDateSlash }
export { calculateDateRangeDays }
export { formatYearMonth }
